/* Callisto: 3 for 2-siden ("Byg dit sæt", sidens skabelon page.3for2) – bjælken nederst, "Læg i sæt", filtre og kurv.
   Flyttet hertil fra sektionen "Custom Liquid", så scriptet ikke forsvinder, når sektionens tekst redigeres. Indlæses kun på 3 for 2-siden. */
(() => {
  if (window.CallistoSetCart) return;

  const SRC = 'callisto-3for2';
  const DAWN_SECTIONS = 'cart-drawer,cart-icon-bubble';
  const root = () => ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const pick = (html, selector) => {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  };
  const safeQuery = sel => { try { return document.querySelector(sel); } catch (_) { return null; } };

  // Kendte cart drawers på tværs af populære temaer
  const DRAWERS = ['cart-drawer-component', 'cart-drawer', 'side-cart', 'cart-drawer-element', '#cart-drawer', '[data-cart-drawer]'];
  const TOGGLES = [
    '[data-cart-drawer-toggle]', '.js-drawer-open-cart', '[aria-controls="CartDrawer"]',
    '[aria-controls*="cart-drawer" i]', '[data-drawer-toggle*="cart" i]', '[data-action="toggle-cart"]',
    '[data-action="open-drawer"][data-drawer-id*="cart" i]', '#cart-icon-bubble', 'header a[href$="/cart"]'
  ];

  const callOpen = (el, trigger, force) => {
    if (!el || (!force && !el.tagName.includes('-'))) return false;
    for (const m of ['open', 'show', 'showDialog', 'openDrawer']) {
      if (typeof el[m] === 'function') { try { el[m](trigger); return true; } catch (_) {} }
    }
    return false;
  };

  const Cart = window.CallistoSetCart = {
    config: {},
    last: null,
    broadcasting: false,

    async get() {
      const r = await fetch(root() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!r.ok) throw new Error('cart');
      return r.json();
    },

    async add(form) {
      if (window.CallistoCart) {
        const id = Number(form.querySelector('[name="id"]').value);
        const qty = Number((form.querySelector('[name="quantity"]') || {}).value || 1);
        const cart = await window.CallistoCart.add([{ id: id, quantity: qty }], false);
        this.last = cart;
        document.querySelectorAll('claury-set-bar').forEach(bar => bar.refresh(cart));
        return cart;
      }
      const body = new FormData(form);
      if (document.querySelector('cart-drawer')) {
        body.append('sections', DAWN_SECTIONS);
        body.append('sections_url', location.pathname);
      }
      const r = await fetch(root() + 'cart/add.js', { method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Smycket kunde inte läggas i varukorgen. Försök igen.');
      await this.sync(data.sections);
      return data;
    },

    async change(key, quantity) {
      if (window.CallistoCart) {
        const r0 = await fetch(root() + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
        if (!r0.ok) throw new Error('change');
        const cart = await window.CallistoCart.refresh(false);
        document.querySelectorAll('claury-set-bar').forEach(bar => bar.refresh(cart));
        return cart;
      }
      const payload = { id: key, quantity };
      if (document.querySelector('cart-drawer')) { payload.sections = DAWN_SECTIONS; payload.sections_url = location.pathname; }
      const r = await fetch(root() + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error('change');
      await this.sync(data.sections, data);
      return data;
    },

    // Holder temaets kurv-ikon og drawer opdateret uden at åbne noget
    async sync(sections, cart) {
      const dawn = document.querySelector('cart-drawer');
      if (sections) {
        const bubble = document.getElementById('cart-icon-bubble');
        const bh = sections['cart-icon-bubble'] ? pick(sections['cart-icon-bubble'], '.shopify-section') : null;
        if (bubble && bh != null) bubble.innerHTML = bh;
        const inner = document.getElementById('CartDrawer');
        const dh = sections['cart-drawer'] ? pick(sections['cart-drawer'], '#CartDrawer') : null;
        if (inner && dh != null) {
          inner.innerHTML = dh;
          const overlay = document.getElementById('CartDrawer-Overlay');
          if (overlay && dawn && typeof dawn.close === 'function') overlay.addEventListener('click', () => dawn.close());
        }
      }
      const c = cart && cart.items ? cart : await this.get().catch(() => null);
      if (!c) return;
      this.last = c;
      if (dawn) dawn.classList.toggle('is-empty', c.item_count === 0);
      this.broadcast(c);
      document.querySelectorAll('claury-set-bar').forEach(bar => bar.refresh(c));
    },

    broadcast(cart) {
      this.broadcasting = true;
      const fire = (target, name, detail) => { try { target.dispatchEvent(new CustomEvent(name, { bubbles: true, detail })); } catch (_) {} };
      fire(document, 'cart:update', { resource: cart, sourceId: SRC, data: { source: SRC, itemCount: cart.item_count } }); // Horizon
      fire(document.documentElement, 'cart:refresh', { cart });                                                            // Prestige, Impact, Focal m.fl.
      fire(document, 'cart:build');                                                                                         // Impulse, Motion
      fire(document, 'theme:cart:reload');
      this.broadcasting = false;
    },

    // Åbner altid temaets cart drawer
    async open(trigger) {
      if (window.CallistoCart) { await window.CallistoCart.refresh(true); return true; }
      const custom = (this.config.drawer || '').trim();
      if (custom && callOpen(safeQuery(custom), trigger, true)) return true;

      const dawn = document.querySelector('cart-drawer');
      if (dawn && typeof dawn.renderContents === 'function') {
        try {
          const r = await fetch(root() + '?sections=' + DAWN_SECTIONS, { credentials: 'same-origin' });
          const sections = await r.json();
          if (sections && sections['cart-drawer']) {
            const c = this.last || await this.get().catch(() => null);
            if (c) dawn.classList.toggle('is-empty', c.item_count === 0);
            dawn.renderContents({ id: null, sections });
            return true;
          }
        } catch (_) {}
      }

      for (const sel of DRAWERS) if (callOpen(safeQuery(sel), trigger)) return true;

      for (const sel of TOGGLES) {
        const t = safeQuery(sel);
        if (t) { t.click(); return true; }
      }
      try { document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true })); } catch (_) {}
      return false;
    }
  };

  // Tilføj fra grid (capture, så temaets egne form-handlers ikke lægger varen i to gange)
  document.addEventListener('submit', async e => {
    const form = e.target.closest && e.target.closest('form[data-cl3-add]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    if (form.dataset.busy) return;
    form.dataset.busy = '1';
    const btn = form.querySelector('.cl3-add');
    const label = btn.querySelector('[data-cl3-label]');
    const feedback = form.querySelector('.cl3-feedback');
    btn.disabled = true; btn.classList.add('is-busy'); feedback.textContent = '';
    try {
      await Cart.add(form);
      btn.classList.add('is-done'); label.textContent = 'Lagd i set';
      clearTimeout(form._t);
      form._t = setTimeout(() => { btn.classList.remove('is-done'); label.textContent = 'Lägg i set'; }, 2200);
    } catch (err) {
      feedback.textContent = err.message || 'Smycket kunde inte läggas i varukorgen. Försök igen.';
    } finally {
      delete form.dataset.busy; btn.disabled = false; btn.classList.remove('is-busy');
    }
  }, true);

  // Variantpris
  document.addEventListener('change', e => {
    const select = e.target.closest && e.target.closest('.cl3-form select');
    if (!select) return;
    const opt = select.options[select.selectedIndex];
    const card = select.closest('.cl3-card');
    card.querySelector('[data-cl3-price]').textContent = opt.dataset.price;
    const compare = card.querySelector('[data-cl3-compare]');
    compare.textContent = opt.dataset.compare || '';
    compare.hidden = !opt.dataset.compare;
  });

  // Filtre
  document.addEventListener('click', e => {
    const chip = e.target.closest && e.target.closest('.cl3-chip');
    if (!chip) return;
    const section = chip.closest('.cl3');
    const f = chip.dataset.filter;
    section.querySelectorAll('.cl3-chip').forEach(c => c.setAttribute('aria-pressed', String(c === chip)));
    section.querySelectorAll('.cl3-card').forEach(card => { card.hidden = !!f && card.dataset.type !== f; });
  });

  if (!customElements.get('claury-set-bar')) customElements.define('claury-set-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try { this.cfg = JSON.parse(this.querySelector('[data-config]').textContent); } catch (_) { this.cfg = {}; }
      Cart.config = Object.assign({}, Cart.config, this.cfg);
      this.types = (this.cfg.types || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
      this.repeat = this.cfg.repeat !== false;
      this.panel = this.querySelector('.cl3-panel');
      this.toggle = this.querySelector('[data-toggle]');
      this.slots = Array.from(this.querySelectorAll('[data-slot]'));
      this.first = true;
      this.refresh = this.refresh.bind(this);

      this.ac = new AbortController();
      const o = { signal: this.ac.signal };
      this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden), o);
      this.querySelector('[data-close]').addEventListener('click', () => this.setOpen(false, true), o);
      this.querySelector('[data-open-cart]').addEventListener('click', async e => {
        const btn = e.currentTarget;
        this.setOpen(false);
        btn.setAttribute('aria-busy', 'true');
        const ok = await Cart.open(btn).catch(() => false);
        btn.removeAttribute('aria-busy');
        if (!ok) location.href = root() + 'cart'; // kun hvis temaet slet ikke har en drawer
      }, o);
      this.querySelector('[data-list]').addEventListener('click', e => {
        const b = e.target.closest('[data-remove]');
        if (b) this.remove(b);
      }, o);
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && !this.panel.hidden) this.setOpen(false, true); }, o);
      document.addEventListener('click', e => { if (!this.panel.hidden && !this.contains(e.target)) this.setOpen(false); }, o);

      const external = () => { if (!Cart.broadcasting) this.refresh(); };
      ['cart:updated', 'cart:refresh', 'cart:change', 'cart:update', 'product:added', 'ajaxProduct:added'].forEach(n => document.addEventListener(n, external, o));
      window.addEventListener('pageshow', this.refresh, o);
      window.addEventListener('focus', this.refresh, o);
      document.addEventListener('visibilitychange', this.refresh, o);

      if ('PerformanceObserver' in window) {
        try {
          this.observer = new PerformanceObserver(list => {
            const hit = list.getEntries().some(entry => {
              try {
                const u = new URL(entry.name, location.href);
                return u.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(u.pathname);
              } catch (_) { return false; }
            });
            if (hit) this.refresh();
          });
          this.observer.observe({ entryTypes: ['resource'] });
        } catch (_) {}
      }
      this.timer = setInterval(() => { if (!document.hidden) this.refresh(); }, 10000);
      this.refresh();
    }

    disconnectedCallback() {
      this.ac && this.ac.abort();
      this.observer && this.observer.disconnect();
      clearInterval(this.timer);
      this.ready = false;
    }

    setOpen(open, returnFocus) {
      this.panel.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));
      this.classList.toggle('is-open', open);
      if (!open && returnFocus) this.toggle.focus({ preventScroll: true });
    }

    async refresh(cart) {
      if (!this.isConnected) return;
      if (cart && cart.items) { this.apply(cart); return; }
      if (document.hidden) return;
      if (this.loading) { this.again = true; return; }
      this.loading = true;
      try {
        this.apply(await Cart.get());
      } catch (_) {
        const err = this.querySelector('[data-error]');
        err.textContent = 'Ditt set kunde inte uppdateras. Öppna varukorgen eller försök igen om en stund.';
        err.hidden = false;
        this.hidden = false;
      } finally {
        this.loading = false;
        if (this.again) { this.again = false; this.refresh(); }
      }
    }

    apply(cart) {
      Cart.last = cart;
      this.hidden = false;
      this.querySelector('[data-error]').hidden = true;
      const sig = JSON.stringify([cart.items.map(i => [i.key, i.quantity]), cart.total_discount]);
      if (sig === this.sig) return;
      this.sig = sig;

      const money = v => {
        const d = v % 100 ? 2 : 0;
        return new Intl.NumberFormat(document.documentElement.lang || 'da-DK', { style: 'currency', currency: cart.currency || 'DKK', minimumFractionDigits: d, maximumFractionDigits: d }).format(v / 100);
      };
      const items = cart.items.filter(i => !i.gift_card && i.handle !== 'gaveaeske' && (!this.types.length || this.types.includes((i.product_type || '').toLowerCase())));
      const units = items.flatMap(i => Array.from({ length: i.quantity }, () => ({ img: i.image, price: i.original_price, key: i.key })));
      const count = units.length;
      const groups = this.repeat ? Math.floor(count / 3) : Math.min(1, Math.floor(count / 3));
      const rem = count % 3;

      let shown;
      if (!this.repeat && groups) shown = units.slice(0, 3);
      else if (count && rem === 0) shown = units.slice(-3);
      else shown = units.slice(count - rem);

      let free = -1;
      if (shown.length === 3) free = shown.reduce((m, u, i) => (u.price < shown[m].price ? i : m), 0);

      this.slots.forEach((slot, i) => {
        const u = shown[i];
        const key = u ? u.key + ':' + i : '';
        if (key !== (slot.dataset.key || '')) {
          slot.replaceChildren();
          if (u && u.img) {
            const img = document.createElement('img');
            img.src = u.img + (u.img.includes('?') ? '&' : '?') + 'width=160';
            img.alt = ''; img.width = 52; img.height = 52;
            slot.append(img);
          }
          slot.classList.remove('is-new');
          if (u && !this.first) { void slot.offsetWidth; slot.classList.add('is-new'); }
          slot.dataset.key = key;
        }
        slot.classList.toggle('is-filled', !!u);
        slot.classList.toggle('is-free', i === free);
        const tag = slot.querySelector('.cl3-tag');
        if (i === free && !tag) {
          const t = document.createElement('span');
          t.className = 'cl3-tag'; t.textContent = 'Gratis';
          slot.append(t);
        } else if (i !== free && tag) tag.remove();
      });

      let title, sub;
      if (!groups) {
        title = count === 0 ? 'Välj 3 smycken – betala för 2' : count === 1 ? 'Välj 2 till' : 'Välj 1 till – så är det billigaste gratis';
        sub = count === 0 ? 'Det billigaste av de 3 är gratis' : count + ' av 3 valda';
      } else {
        title = groups === 1 ? 'Ditt set är komplett' : 'Du har ' + groups + ' kompletta set';
        sub = cart.total_discount > 0 ? 'Du sparar ' + money(cart.total_discount) : 'Rabatten visas i varukorgen';
        if (this.repeat && rem) sub += '. Välj ' + (3 - rem) + ' till för nästa set';
      }
      this.querySelector('[data-title]').textContent = title;
      this.querySelector('[data-sub]').textContent = sub;
      this.querySelector('[data-qty]').textContent = cart.item_count ? String(cart.item_count) : '';
      if (!this.first && this.prevCount !== count) this.querySelector('[data-live]').textContent = title + '. ' + sub;
      this.prevCount = count;
      this.first = false;

      const list = this.querySelector('[data-list]');
      list.replaceChildren();
      items.forEach(item => {
        const li = document.createElement('li'); li.className = 'cl3-item';
        if (item.image) {
          const img = document.createElement('img');
          img.src = item.image + (item.image.includes('?') ? '&' : '?') + 'width=120';
          img.alt = ''; img.width = 52; img.height = 64; img.loading = 'lazy';
          li.append(img);
        }
        const copy = document.createElement('div'); copy.className = 'cl3-item-copy';
        const a = document.createElement('a'); a.href = item.url; a.textContent = item.product_title; copy.append(a);
        const small = document.createElement('small');
        small.textContent = [item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '', item.quantity + ' stk.', money(item.final_line_price)].filter(Boolean).join(', ');
        copy.append(small); li.append(copy);
        const rm = document.createElement('button');
        rm.type = 'button'; rm.className = 'cl3-remove'; rm.dataset.remove = item.key; rm.textContent = 'Fjern';
        rm.setAttribute('aria-label', 'Fjern ' + item.product_title + ' fra kurven');
        li.append(rm); list.append(li);
      });
      this.querySelector('[data-empty]').hidden = items.length > 0;
    }

    async remove(button) {
      if (this.removing) return;
      this.removing = true;
      const buttons = this.querySelectorAll('[data-remove]');
      buttons.forEach(b => { b.disabled = true; });
      const err = this.querySelector('[data-error]');
      err.hidden = true;
      try {
        await Cart.change(button.dataset.remove, 0);
        this.querySelector('[data-close]').focus({ preventScroll: true });
      } catch (_) {
        err.textContent = 'Smycket kunde inte tas bort. Försök igen eller öppna varukorgen.';
        err.hidden = false;
        buttons.forEach(b => { b.disabled = false; });
      } finally {
        this.removing = false;
      }
    }
  });
})();
